"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;





































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Tinymce: _Tinymce.default }, data: function data() {return { tableData: [], // 列表数据
      title: '', searchData: { name: '', code: '', ltTemp: '', gtTemp: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'name', label: '姓名', isShow: true }, { prop: 'sex', label: '性别', formatter: function formatter(row, column, val) {return val === 1 ? '男' : '女';}, isShow: true }, { prop: 'mobile', label: '电话', isShow: true }, { prop: 'codeType', label: '编号类型', formatter: function formatter(row, column, cellValue) {return cellValue ? '工号' : '学号';}, isShow: true }, { prop: 'code', label: '编号', isShow: true }, { prop: 'temperature', label: '体温', formatter: function formatter(row, column, cellValue) {return cellValue + '°C';}, isShow: true }, { prop: 'createTime', label: '测量时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'pictureUrl', label: '拍摄照片', isShow: false }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temp', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.code = '';this.searchData.ltTemp = '';this.searchData.gtTemp = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;var ltTemp = this.searchData.ltTemp;var gtTemp = this.searchData.gtTemp;if (this.searchData.ltTemp) {if (ltTemp > gtTemp) {this.searchData.gtTemp = "";this.$message({ showClose: true, message: '最高体温不能低于最低体温', type: 'error' });}
      }
      if (this.searchData.gtTemp) {
        if (gtTemp < ltTemp) {
          this.searchData.ltTemp = "";
          this.$message({
            showClose: true,
            message: '最高体温不能低于最低体温',
            type: 'error' });

        }
      }
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    } } };exports.default = _default;